<template>
  <v-container class="text-center">
    <v-row align="center">
      <v-col>
        <h1 class="display-2 primary--text">Error, 401</h1>

        <p>
          Unauthorized
        </p>

        <v-btn :to="{ name: 'LandingPage' }" color="primary" outlined class="mr-2">
          Go back home
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';

export default {
  name: 'Page401',
  mixins: [util],
};
</script>
